import React from 'react'

import { Box } from '~/components/elements/Box'
import { SearchInput } from '~/components/elements/SearchInput'
import { StyledCard } from '~/components/elements/StyledCard/StyledCard'
import { exists } from '~/utils'

import styles from './TreeViewBox.css'

export type TreeViewBoxProps = {
  'data-testid'?: string
  search?: {
    filter: string
    onFilterChange: (filter: string) => void
  }
  selectedTitle: string
  selectedTreeView: React.ReactNode
  unselectedTitle: string
  unselectedTreeView: React.ReactNode
}

export const TreeViewBox = ({
  'data-testid': dataTestId = 'components-elements-tree-view-box',
  search,
  selectedTitle,
  selectedTreeView,
  unselectedTitle,
  unselectedTreeView,
}: TreeViewBoxProps) => {
  const headerContent = React.useMemo(
    () =>
      exists(search) ? (
        <SearchInput
          className={styles.searchInput}
          value={search.filter}
          onChange={search.onFilterChange}
        />
      ) : undefined,
    [search],
  )

  return (
    <Box className={styles.root} data-testid={dataTestId}>
      <StyledCard
        headerContent={headerContent}
        headerJustify="space-between"
        title={unselectedTitle}
      >
        {unselectedTreeView}
      </StyledCard>

      <StyledCard title={selectedTitle}>{selectedTreeView}</StyledCard>
    </Box>
  )
}
